import { render, staticRenderFns } from "./xeChartHorizontalBar.vue?vue&type=template&id=b5cb2aac"
import script from "./xeChartHorizontalBar.vue?vue&type=script&lang=js"
export * from "./xeChartHorizontalBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports